import { render, staticRenderFns } from "./ContentOrLoading.vue?vue&type=template&id=1d731792"
import script from "./ContentOrLoading.vue?vue&type=script&lang=js"
export * from "./ContentOrLoading.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports